import { render, staticRenderFns } from "./WorkerPersonalDataTab.vue?vue&type=template&id=74db3f58&"
import script from "./WorkerPersonalDataTab.vue?vue&type=script&lang=js&"
export * from "./WorkerPersonalDataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports